export const INTERVIEW_JOIN_EARLY_WINDOW_MINUTES = 2;

const toDate = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (typeof value?.seconds === 'number') return new Date(value.seconds * 1000);

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
};

export const getInterviewPortalPath = (meetingId) => {
  const normalizedMeetingId = String(meetingId || '').trim();
  if (!normalizedMeetingId) {
    return '/interviews';
  }

  return `/interviews/${encodeURIComponent(normalizedMeetingId)}`;
};

export const getInterviewJoinAvailability = (scheduledFor, now = new Date()) => {
  const scheduledStart = toDate(scheduledFor);
  if (!scheduledStart) {
    return {
      scheduledStart: null,
      availableAt: null,
      canJoin: true,
      remainingMs: 0,
      isScheduled: false
    };
  }

  const availableAt = new Date(scheduledStart.getTime() - (INTERVIEW_JOIN_EARLY_WINDOW_MINUTES * 60 * 1000));
  const remainingMs = Math.max(0, availableAt.getTime() - now.getTime());

  return {
    scheduledStart,
    availableAt,
    canJoin: remainingMs <= 0,
    remainingMs,
    isScheduled: true
  };
};
